import React from 'react';
import { NavLink } from 'react-router-dom';
import { ShoppingCart, Smartphone, RefreshCw, Users, Package, Settings, LogOut, UserCheck, Clock, Activity } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
export const Sidebar: React.FC = () => {
  const {
    user,
    logout
  } = useAuth();
  const navItems = [{
    to: '/orders',
    icon: <ShoppingCart size={20} />,
    label: 'Orders Report'
  }, {
    to: '/esims',
    icon: <Smartphone size={20} />,
    label: 'E-SIM Report'
  }, {
    to: '/topup',
    icon: <RefreshCw size={20} />,
    label: 'Top-Up E-SIM'
  }, {
    to: '/users',
    icon: <Users size={20} />,
    label: 'User Management'
  }];

  // Driver Management section
  const driverNavItems = [{
    to: '/driver-users',
    icon: <UserCheck size={20} />,
    label: 'Users'
  }, {
    to: '/driver-audit',
    icon: <Clock size={20} />,
    label: 'Audit & History'
  }, {
    to: '/background-jobs',
    icon: <Activity size={20} />,
    label: 'Background Jobs'
  }];
  // Add Package Management only for admin
  if (user?.role === 'admin') {
    navItems.push({
      to: '/packages',
      icon: <Package size={20} />,
      label: 'Package Management'
    });
    navItems.push({
      to: '/settings',
      icon: <Settings size={20} />,
      label: 'Settings'
    });
  }
  return <aside className="w-64 bg-alps-primary text-white hidden md:flex flex-col min-h-0">
      {/* Logo */}
      <div className="p-6">
        <h2 className="text-xl font-bold">E-SIM Admin</h2>
      </div>
      {/* Navigation */}
      <nav className="flex-1 px-4 py-2 overflow-y-auto">
        <ul className="space-y-1">
          {navItems.map(item => <li key={item.to}>
              <NavLink to={item.to} className={({
            isActive
          }) => `flex items-center px-4 py-3 rounded-lg transition-colors ${isActive ? 'bg-alps-primary-dark text-white' : 'text-white hover:bg-alps-primary-dark'}`}>
                {item.icon}
                <span className="ml-3">{item.label}</span>
              </NavLink>
            </li>)}
        </ul>
        
        {/* Driver Management Section */}
        <div className="mt-8">
          <div className="px-4 py-2">
            <h3 className="text-sm font-semibold text-white/70 uppercase tracking-wider">Driver Management</h3>
          </div>
          <ul className="space-y-1">
            {driverNavItems.map(item => <li key={item.to}>
                <NavLink to={item.to} className={({
              isActive
            }) => `flex items-center px-4 py-3 rounded-lg transition-colors ${isActive ? 'bg-alps-primary-dark text-white' : 'text-white hover:bg-alps-primary-dark'}`}>
                  {item.icon}
                  <span className="ml-3">{item.label}</span>
                </NavLink>
              </li>)}
          </ul>
        </div>
      </nav>
      {/* User Info & Logout */}
      <div className="p-4 border-t border-alps-primary-dark">
        <div className="flex items-center mb-4">
          <div className="w-10 h-10 rounded-full bg-alps-primary-dark flex items-center justify-center">
            <span className="text-lg font-medium">{user?.name?.[0]}</span>
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium">{user?.name}</p>
            <p className="text-xs text-white capitalize">{user?.role}</p>
          </div>
        </div>
        <button onClick={logout} className="flex items-center w-full px-4 py-2 text-white rounded-lg hover:bg-alps-primary-dark transition-colors">
          <LogOut size={20} />
          <span className="ml-3">Logout</span>
        </button>
      </div>
    </aside>;
};
